import { z } from "zod";
const renderWatermarkSchema = z.object({
    show: z.boolean(),
    vidhug: z.string(),
    downloadUrl: z.string().nullable(),
    cdnUrl: z.string().nullable().optional(),
    size: z.number(),
    opacity: z.number(),
    margin: z.number(),
    fadeSeconds: z.number(),
    useCustom: z.boolean().optional(),
});
const textSequenceSchema = z.object({
    include: z.boolean(),
    text: z.array(z.string()),
    textFont: z.string(),
    textFontWeight: z.string(),
    textScale: z.number(),
    writeTime: z.number(),
    showTime: z.number(),
    startDelay: z.number(),
});
const collageGridConfigSchema = z.object({
    rows: z.number(),
    minClips: z.number(),
});
export const collageConfigSchema = z.object({
    showFaces: z.boolean(),
    colorMap: z.string().nullable(),
    baseCollageColor: z.union([z.string(), z.array(z.string())]).nullable(),
    borderThickness: z.number(),
    solidColor: z.boolean().optional(),
    showDuringHugs: z.boolean().optional(),
    borderColorHex: z.string(),
    maxFaces: z.number(),
    configs: z.array(collageGridConfigSchema),
});
export const musicConfigSchema = z.object({
    include: z.boolean(),
    originUrl: z.string(),
    cdnUrl: z.string().optional(),
    mp3File: z.string().nullable(),
    key: z.string().nullable(),
    fadeLevel: z.number(),
});
export const clipTextConfigSchema = z.object({
    header: z.string().nullable(),
    headerFont: z.string(),
    headerFontWeight: z.string(),
    subHeader: z.string().nullable().optional(),
    subHeaderFont: z.string(),
    subHeaderFontWeight: z.string(),
    transitionTime: z.number(),
    startDelay: z.number(),
    maxShowTime: z.number(),
    headerScale: z.number(),
    subHeaderScale: z.number(),
    headerDownShift: z.number(),
});
export const clipConfigSchema = z.object({
    url: z.string().nullable(),
    cdnUrl: z.string().nullable().optional(),
    rotateAngle: z.number(),
    cutInfo: z.object({
        cut: z.boolean(),
        start: z.number(),
        end: z.number(),
    }),
    normalizeVolume: z.boolean(),
    muteMusic: z.boolean(),
    text: clipTextConfigSchema.nullable(),
});
// This is named renderConfigV2Schema instead of renderRequestV2Schema because
// almost everywhere it's used, it's referred to as `config` or `renderConfig`.
export const renderConfigV2Schema = z.object({
    compilationId: z.string().nullable(),
    compilationWidth: z.number(),
    compilationHeight: z.number(),
    outBucket: z.string(),
    localDebug: z.boolean(),
    watermark: renderWatermarkSchema,
    lambdas: z.object({
        renderComplete: z.string(),
    }),
    stsRole: z.object({
        roleArn: z.string(),
        roleSessionName: z.string(),
    }),
    transitionSeconds: z.number(),
    audio: z.object({
        earlyFadeSeconds: z.number(),
        maxGain: z.number(),
    }),
    smoothnessScale: z.number(),
    intro: textSequenceSchema,
    outro: textSequenceSchema,
    collage: collageConfigSchema,
    backgroundMusic: musicConfigSchema,
    clips: z.array(clipConfigSchema),
});
